import { Client } from "@/core";

type ClientDisplayFields = Pick<
  Client,
  | "companyName"
  | "firstName"
  | "lastName"
  | "email"
  | "phone"
  | "secondaryEmail"
  | "secondaryPhone"
  | "type"
>;

export function getClientFullName({
  client,
}: {
  client: Pick<ClientDisplayFields, "firstName" | "lastName">;
}) {
  return `${client.firstName} ${client.lastName}`.trim();
}

export function getClientDisplayName({
  client,
}: {
  client: Pick<
    ClientDisplayFields,
    "companyName" | "firstName" | "lastName" | "email"
  >;
}) {
  const companyName = client.companyName?.trim() || "";
  const fullName = getClientFullName({ client });

  return [companyName, fullName].filter(Boolean).join(" · ") || client.email?.trim() || "Client";
}

export function getClientSearchKeywords({
  client,
}: {
  client: ClientDisplayFields;
}) {
  return [
    client.companyName,
    client.firstName,
    client.lastName,
    client.email,
    client.phone,
    client.secondaryEmail,
    client.secondaryPhone,
    client.type,
  ].filter((value): value is string => Boolean(value?.trim()));
}

export function getClientSelectLabel({
  client,
}: {
  client: Pick<
    ClientDisplayFields,
    "companyName" | "firstName" | "lastName" | "email"
  >;
}) {
  const displayName = getClientDisplayName({ client });

  if (!client.email?.trim()) {
    return displayName;
  }

  return displayName === client.email ? client.email : `${displayName} (${client.email})`;
}
